import script from "./OkrElementsFormNumberInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OkrElementsFormNumberInput.vue?vue&type=script&setup=true&lang=js"

import "./OkrElementsFormNumberInput.vue?vue&type=style&index=0&id=61837c20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61837c20"]])

export default __exports__